import { pulseAxiosInstance } from "./axiosInstance";

export type Driver = {
    id: number;
    taxonomyId: number;
    title_no: string;
    title_en: string;
};

export const getDrivers = async (): Promise<Driver[]> => {
    const response = await pulseAxiosInstance.get<Driver[]>("/drivers");
    return response.data;
};
